document.getElementById('checkout')?.addEventListener('click', async function(e) {
  e.preventDefault();
  e.stopPropagation();

  //window.location.href = '/checkout'

  await validCart(this);
}, true);  // useCapture = true，确保在其他事件之前执行


async function validCart(btn){
   
  btn.disabled = true;
  btn.textContent = 'Validating...';

    try {
    // 1. 获取真实 cart
    const cartRes = await fetch('/cart.json');
    const cart = await cartRes.json();
    
    // 2. 构建 variant_id -> quantity 映射
    const variantQtyMap = {};
    cart.items.forEach(item => {
      variantQtyMap[item.variant_id] = item.quantity;
    });
    
    // 3. 验证 _DaSurchargeItem_ 和数量
    let isValid = true;
    let errorMsg = '';
    
    for (const item of cart.items) {
      if (item.properties && item.properties._DaSurchargeItem_) {
        const surchargeId = parseInt(item.properties._DaSurchargeItem_);
        const requiredQty = item.quantity;
        
        // 检查对应的 surcharge item 是否存在
        if (!variantQtyMap.hasOwnProperty(surchargeId)) {
          isValid = false;
          errorMsg = `Required surcharge item (ID: ${surchargeId}) is missing from cart.`;
          break;
        }
        
        // 检查数量是否足够
        const surchargeQty = variantQtyMap[surchargeId];
        if (surchargeQty < requiredQty) {
          isValid = false;
          errorMsg = `Insufficient surcharge item. Required: ${requiredQty}, Available: ${surchargeQty}`;
          break;
        }
      }
    }
    
    if (!isValid) {
      alert(errorMsg);
      btn.disabled = false;
      btn.textContent = 'Check out';
      return;
    }
       
    // 5. 跳转到 checkout
    window.location.href = '/checkout';
    
  } catch (err) {
    console.error('Cart validation error:', err);
    btn.disabled = false;
    btn.textContent = 'Check out';
  }
}


document.getElementById('CartDrawer-Checkout')?.addEventListener('click', async function(e) {
  e.preventDefault();
  e.stopPropagation();

  await validCart(this)
  
  
});